import { getDataFromServer } from '../../../util';

export class CustomerTypeListModule {
  constructor(baseURL, httpHeaders) {
    this.baseURL = baseURL;
    this.httpHeaders = httpHeaders;
  }

  fetchCustomerTypeList = async (payload) => {
    const params = {
      metaName: 'customertype'
    };

    const url = `${this.baseURL}/meta`;
    const data = await getDataFromServer(url, this.httpHeaders, params);
    if (Array.isArray(data) && data.length > 0) {
      return data.map((customerType) => ({
        label: customerType,
        value: customerType
      }));
    }

    return [];
  };
}
